export default (editor, opts = {}) => {

    const DOMC = editor.DomComponents;
    const BM = editor.BlockManager;
    const COMMANDS = editor.Commands;
    const TYPE = DOMC.getType('default');
    const MODEL = TYPE.model;
    const VIEW = TYPE.view;

    /* Component modal sponsors */
    let model = MODEL.extend({
        defaults:{
            ...MODEL.prototype.defaults,  
            name:"Modal Sponsors",
            tagName:'div',
            attributes:{
                id:"sponsor",
                "data-slg-type":"C-MODAL-SPONSORS",
                tabindex:'-1',
                "aria-labelledby":"modal-sponsors",
                "aria-hidden":"true"
            },
            classes:['modal','fade'],
            droppable: false, 
            components:[
                {
                    name:"Modal Dialog",
                    tagName:'div',
                    droppable:false,
                    draggable: false,
                    classes:['modal-dialog'],
                    components:[
                        {
                            name:"Modal Container",
                            tagName:'div',
                            droppable:false,
                            draggable: false,
                            classes:['modal-content'],
                            components:[
                                /* Modal header */
                                {
                                    name:"Modal Header",
                                    tagName:'div',
                                    // droppable:false,
                                    draggable: false,
                                    classes:['modal-header'],
                                    components:[
                                        /* Modal title */
                                        {
                                            name:"Modal Title",
                                            type:'header',
                                            tagName:"h3",
                                            droppable:false,
                                            draggable: false,
                                            classes:['modal-title'],
                                            components:[
                                                {
                                                    type:"textnode",
                                                    content:'Title'
                                                }
                                            ]
                                            
                                        },
                                        /* Modal close */
                                        {
                                            name:"Close",
                                            tagName:'button',
                                            droppable:false,
                                            draggable: false,
                                            attributes:{
                                                'data-slg-control-dismiss':'modal',
                                                'aria-label':'Close',
                                                'type':'button',
                                                'data-dismiss':"modal"
                                            },
                                            classes:['close','btn-close'],
                                            /* content:'<i class="fas fa-times"></i>' */
                                            components:/*html*/`
                                                <span aria-hidden="true">&times;</span>
                                            `
                                        }
                                    ]
                                },
                                {
                                    name:"Modal Body",
                                    tagName:'div',
                                    // droppable:false,
                                    draggable: false,
                                    classes:['modal-body'],
                                    components:[
                                        {
                                            name:"Default Text",
                                            droppable:false,
                                            draggable: false,
                                            type:'paragraph',
                                            content:'Insert default sponsors text here.'
                                        },
                                        {
                                            name:"Sponsors Container",
                                            tagName: 'div',
                                            droppable:false,
                                            draggable: false,
                                            classes:['modal-content-sponsors'],
                                            components:[
                                                {
                                                    name:"Sponsor Title",
                                                    type:"header",
                                                    tagName:'h4',
                                                    droppable:false,
                                                    draggable: false,
                                                    editable:true,
                                                    content:'Current sponsors of the promotion',
                                                    classes:['sponsors-title'],
                                                    attributes:{
                                                        id:"modal-sponsors"
                                                    }
                                                },
                                                {
                                                    name:"Sponsors List",
                                                    tagName:'div',
                                                    droppable:false,
                                                    draggable: false,
                                                    editable:false,
                                                    attributes:{
                                                        id:'sponsors_all'
                                                    },
                                                    classes:['sponsor-list'],
                                                    content:"¡¡The list sponsors generate here!!"
                                                }

                                            ]    
                                        }
                                    ]
                                },
                                {
                                    name:"Modal Footer",
                                    tagName:'div',
                                    // droppable:false,
                                    draggable: false,
                                    classes:['modal-footer'],
                                    components:[
                                        {
                                            type:"button",
                                            tagName:'button',
                                            editable:true,
                                            content:'Close',
                                            classes:['btn','btn-close','btn-secondary'],
                                            attributes:{
                                                'data-slg-control-close':'#sponsor',
                                                'type':'button',
                                                'data-dismiss':"modal"
                                            }
                                        },
                                    ]
                                }
                            ]

                        }
                    ]
                        
                }
            ]
        }
        
    },{
        isComponent(el) {
            if(el && el.getAttribute && el.getAttribute('data-slg-type') == "C-MODAL-SPONSORS")
                return { type:'C-MODAL-SPONSORS' }
        }
    });

    let view = VIEW.extend({
        onRender(){
            let component = this.model;
            this.initModalSponsors();
        },
        initModalSponsors(){

            let canvas_document = editor.Canvas.getDocument();
            let el = this.el;
            let btns_close = el.querySelectorAll(`.btn-close`);
            let modal_content = el.querySelector('.modal-content');

            /* Event button closed modal */
            if(btns_close.length > 0){
                Array.from(btns_close).forEach((btn_close)=>{
                    btn_close.addEventListener('click', (e)=>{
                        el.classList.remove('show');
                        el.style.display = "";
                        canvas_document.querySelector('.modal-backdrop').remove();
                    }); 
                })
                   
            }
            
            /* Event click outside modal */
            if(el){
                el.addEventListener('click', function(e){   
                    if (modal_content.contains(e.target)){
                        // Clicked in box
                    } else{
                        // Clicked outside the box
                        el.classList.remove('show');
                        el.style.display = "";
                        canvas_document.querySelector('.modal-backdrop').remove();
                    }
                });
            }
            
        },
    });

    DOMC.addType('C-MODAL-SPONSORS', {
        model,
        view
    });
    
};
  